import { Component } from 'react';
import { DebugEx } from '../../Utils/DebugEx';
import { grey600, red200 } from '@Utils/Colors';
import { Button } from '@Primitive/Button';
import { Props } from '@Utils/ReactProps';
// ------------------------------------------------------------------------------------------------
interface ErrorCatchProps extends Props<ErrorCatch> { }
// ------------------------------------------------------------------------------------------------
interface ErrorCatchState {
    hasError: boolean;
}
// ------------------------------------------------------------------------------------------------
export class ErrorCatch extends Component<ErrorCatchProps, ErrorCatchState> {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }
    // ------------------------------------------------------------------------------------------------
    componentDidCatch(error, info) {
        DebugEx.TraceException(error, info);
        this.setState({ hasError: true });
    }
    // --------------------------------------------------------------------------------------------
    render() {
        if (this.state.hasError)
            return <div
                style={{
                    width: '100%',
                    height: '100%',
                    textAlign: 'center',
                    fontSize: 'medium',
                    fontWeight: 700,
                    backgroundColor: '#e5e3df',
                    color: grey600,
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex'
                }}>
                <div>
                    <i className='fas fa-exclamation-square' style={{
                        width: 32,
                        height: 32,
                        color: red200
                    }} />
                    <p>{'Oops! Something went wrong'}</p>
                    <Button
                        key='reset'
                        label='Reset widget'
                        height={40}
                        shadowLevel={0}
                        style={{ background: 'transparent' }}
                        onClick={() => this.setState({ hasError: false })}
                    />
                </div>
            </div>;

        return this.props.children;
    }
}
// ------------------------------------------------------------------------------------------------